var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverflowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66634 9.33333C1.94294 9.33333 1.33301 8.73759 1.33301 8C1.33301 7.26241 1.92875 6.66667 2.66634 6.66667C3.38975 6.66667 3.99967 7.26241 3.99967 8C3.99967 8.73759 3.40393 9.33333 2.66634 9.33333ZM7.99967 9.33333C7.27627 9.33333 6.66634 8.73759 6.66634 8C6.66634 7.26241 7.26209 6.66667 7.99967 6.66667C8.73726 6.66667 9.33301 7.26241 9.33301 8C9.33301 8.73759 8.72308 9.33333 7.99967 9.33333ZM13.333 9.33333C12.6096 9.33333 11.9997 8.73759 11.9997 8C11.9997 7.26241 12.5954 6.66667 13.333 6.66667C14.0706 6.66667 14.6663 7.26241 14.6663 8C14.6663 8.73759 14.0564 9.33333 13.333 9.33333Z",
    fill: "#1F2532"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_451_40222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 14,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66634 9.33333C1.94294 9.33333 1.33301 8.73759 1.33301 8C1.33301 7.26241 1.92875 6.66667 2.66634 6.66667C3.38975 6.66667 3.99967 7.26241 3.99967 8C3.99967 8.73759 3.40393 9.33333 2.66634 9.33333ZM7.99967 9.33333C7.27627 9.33333 6.66634 8.73759 6.66634 8C6.66634 7.26241 7.26209 6.66667 7.99967 6.66667C8.73726 6.66667 9.33301 7.26241 9.33301 8C9.33301 8.73759 8.72308 9.33333 7.99967 9.33333ZM13.333 9.33333C12.6096 9.33333 11.9997 8.73759 11.9997 8C11.9997 7.26241 12.5954 6.66667 13.333 6.66667C14.0706 6.66667 14.6663 7.26241 14.6663 8C14.6663 8.73759 14.0564 9.33333 13.333 9.33333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_451_40222)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflowIcon);
export default __webpack_public_path__ + "static/media/overflow-icon.cb9a22697f0409babd8cc639a2ed0fcc.svg";
export { ForwardRef as ReactComponent };